import { render } from "./tools-canvas.vue?vue&type=template&id=6a5026a9&scoped=true&ts=true"
import script from "./tools-canvas.ts?vue&type=script&lang=ts&external"
export * from "./tools-canvas.ts?vue&type=script&lang=ts&external"

import "./tools-canvas.vue?vue&type=style&index=0&id=6a5026a9&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a5026a9"]])

export default __exports__